import { useMutation, useQueryClient } from "@tanstack/react-query"

import { updateQuestionOption } from "../../services/questionOptions";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useUpdateQuestionOption = (indicator: IIndicators) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateQuestionOption,
        onMutate: () => {
            indicator.setIsProcessRunning(true);
            indicator.setIsServiceError(null);
        },
        onSuccess: (statusCode) => {
            if (statusCode === 200) {
                queryClient.invalidateQueries({ queryKey: ["question-options"] });
                indicator.setIsProcessRunning(false);
                indicator.setIsServiceError(null);
                toast.success("Question option updated successfully");
            }
        },
        onError: (error: any) => {
            indicator.setIsServiceError(error?.response?.data?.message);
            indicator.setIsProcessRunning(false);
            toast.error(error?.response?.data?.message);
        }
    })
}

export default useUpdateQuestionOption;